import { AppRoutes } from '../../core/routes/routes';

export const basePath = `editor`;

export const baseUrl = `/${basePath}`;

export const routes = {
  tasks: {
    index: {
      path: 'tasks',
      url: () => `${baseUrl}/tasks`,
    },
    detail: {
      path: 'tasks/:id',
      url: (taskId: string) => `${baseUrl}/tasks/${taskId}`,
    },
  },
  settings: {
    index: {
      path: 'settings',
      url: () => `${baseUrl}/settings`,
    },
    account: {
      path: 'account',
      url: () => `${baseUrl}/settings/account`,
    },
  },
  help: {
    index: {
      path: 'help',
      url: () => `${baseUrl}/help`,
    },
  },
} as const satisfies AppRoutes;
